import { getUrlWithPreviewThemeId } from '@/scripts/core/global'

let personalizationBadgeInitialized = false

export function initializePersonalizationBadgeTriggers() {
	if (personalizationBadgeInitialized) return
	personalizationBadgeInitialized = true

	document.addEventListener('click', (event: MouseEvent) => {
		const target = event.target as HTMLElement | null
		if (!target) return
		const trigger = target.closest<HTMLAnchorElement>(
			'.personalization-route-link'
		)
		if (!trigger) return
		if (trigger.classList.contains('disabled')) {
			event.preventDefault()
			return
		}
		if (
			event.button !== 0 ||
			event.metaKey ||
			event.ctrlKey ||
			event.shiftKey ||
			event.altKey
		)
			return
		event.preventDefault()
		window.location.href = getUrlWithPreviewThemeId(trigger.href).toString()
	})
}
